"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewGroupBy = exports.ViewColorBy = exports.ServiceCancellation = exports.ShiftCancellation = exports.JobPayType = exports.DayNumbersArray = exports.NoteEntityType = exports.MetaT = exports.MetaSettingT = exports.SubRosterMasterT = exports.LinkedRosterT = exports.LeaveT = exports.JobT = exports.IgnoredUnavailabilityT = exports.GridExceptions = void 0;
const t = __importStar(require("@sinclair/typebox"));
const universal_1 = require("../universal");
const types_roster_server_1 = require("./types-roster-server");
class GridExceptions {
    services;
    shifts;
    shiftGaps;
    constructor() {
        this.services = {};
        this.shiftGaps = {};
        this.shifts = {};
    }
    add(index, key, exception) {
        const obj = this[index][key];
        if (obj) {
            obj.add(exception);
        }
        else {
            this[index][key] = new Set([exception]);
        }
    }
    addService(key, exception) {
        this.add('services', key, exception);
    }
    addShift(key, exception) {
        this.add('shifts', key, exception);
    }
    addShiftGap(key, exception) {
        this.add('shiftGaps', key, exception);
    }
}
exports.GridExceptions = GridExceptions;
exports.IgnoredUnavailabilityT = t.Object({
    ID: t.Number(),
    Date: (0, universal_1.DateObjT)(),
    User: t.String(),
});
exports.JobT = t.Object({
    Active: universal_1.tBoolT,
    CC: t.Array(t.Number()),
    Classification: t.Number(),
    Company: t.Number(),
    ContractHours: (0, universal_1.MaybeT)(t.Number()),
    ContractHoursMax: (0, universal_1.MaybeT)(t.Number()),
    DefaultArea: (0, universal_1.MaybeT)(t.Number()),
    DynamicCC: universal_1.tBoolT,
    Employee: t.Number(),
    EndDate: (0, universal_1.MaybeT)((0, universal_1.DateObjT)()),
    ID: t.Number(),
    IsDefault: universal_1.tBoolT,
    LegacyKey: (0, universal_1.MaybeT)(t.Number()),
    PHBR: universal_1.tBoolT,
    PayType: types_roster_server_1.JobPayTypeT,
    StartDate: (0, universal_1.DateObjT)(),
    WorkType: t.Union([t.Literal('P'), t.Literal('C'), t.Literal('F')]),
});
exports.LeaveT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    Code: t.String(),
    ShortName: t.String(),
    Casual: universal_1.tBoolT,
    Enabled: universal_1.tBoolT,
    Transferred: universal_1.tBoolT,
    Costed: universal_1.tBoolT,
    PayrollCategory: t.String(),
    PrivacyName: t.String(),
});
exports.LinkedRosterT = t.Object({
    ID: t.Number(),
    MasterRoster: t.Number(),
    LinkedRoster: t.Number(),
    SubRoster: t.Number(),
});
exports.SubRosterMasterT = t.Object({
    Key: t.Number(),
    Name: t.String(),
    Rosters: t.Array(t.Object({ ID: t.Number(), Name: t.String() })),
});
exports.MetaSettingT = t.Object({
    Description: t.String(),
    Hidden: t.Boolean(),
    Name: t.String(),
    Type: t.String(),
    Value: t.Any(),
});
exports.MetaT = t.Object({
    CompanyName: t.String(),
    DefaultActual: universal_1.tBoolT,
    Facility: t.Number(),
    HasBilling: (0, universal_1.MaybeT)(t.Boolean()),
    IsCDC: t.Boolean(),
    IsLive: t.Boolean(),
    LastRecalc: (0, universal_1.MaybeT)((0, universal_1.DateTimeObjT)()),
    LastRecalcLong: (0, universal_1.MaybeT)((0, universal_1.DateTimeObjT)()),
    Name: t.String(),
    PayrollVersion: t.String(),
    Settings: t.Record(t.String(), exports.MetaSettingT),
    SharedClockings: universal_1.tBoolT,
    SubBilling: (0, universal_1.MaybeT)(t.Number()),
    SubRoster: t.Number(),
    SysVals: t.Object({
        SchemaDate: (0, universal_1.DateObjT)(),
        CDCMaxGap: (0, universal_1.MaybeT)(t.Number()),
    }),
    SubRosterMasters: (0, universal_1.MaybeT)((0, universal_1.ModelTypeT)(exports.SubRosterMasterT)),
});
var NoteEntityType;
(function (NoteEntityType) {
    NoteEntityType[NoteEntityType["Roster"] = 0] = "Roster";
    NoteEntityType[NoteEntityType["Shift"] = 1] = "Shift";
    NoteEntityType[NoteEntityType["Service"] = 2] = "Service";
    NoteEntityType[NoteEntityType["Employee"] = 3] = "Employee";
    NoteEntityType[NoteEntityType["Client"] = 4] = "Client";
    NoteEntityType[NoteEntityType["ServiceSchedule"] = 5] = "ServiceSchedule";
})(NoteEntityType || (exports.NoteEntityType = NoteEntityType = {}));
exports.DayNumbersArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
var JobPayType;
(function (JobPayType) {
    JobPayType[JobPayType["PayByShift"] = 1] = "PayByShift";
    JobPayType[JobPayType["PayByTask"] = 2] = "PayByTask";
})(JobPayType || (exports.JobPayType = JobPayType = {}));
var ShiftCancellation;
(function (ShiftCancellation) {
    ShiftCancellation[ShiftCancellation["NotCancelled"] = 0] = "NotCancelled";
    ShiftCancellation[ShiftCancellation["CancelledUnpaid"] = 1] = "CancelledUnpaid";
    ShiftCancellation[ShiftCancellation["CancelledPaid"] = 2] = "CancelledPaid";
})(ShiftCancellation || (exports.ShiftCancellation = ShiftCancellation = {}));
var ServiceCancellation;
(function (ServiceCancellation) {
    ServiceCancellation[ServiceCancellation["NotCancelled"] = 0] = "NotCancelled";
    ServiceCancellation[ServiceCancellation["CancelledCharged"] = 1] = "CancelledCharged";
    ServiceCancellation[ServiceCancellation["CancelledNotCharged"] = 2] = "CancelledNotCharged";
})(ServiceCancellation || (exports.ServiceCancellation = ServiceCancellation = {}));
var ViewColorBy;
(function (ViewColorBy) {
    ViewColorBy[ViewColorBy["ShiftTemplate"] = 0] = "ShiftTemplate";
    ViewColorBy[ViewColorBy["Area"] = 1] = "Area";
    ViewColorBy[ViewColorBy["ServiceType"] = 2] = "ServiceType";
    ViewColorBy[ViewColorBy["ServiceAssigned"] = 3] = "ServiceAssigned";
    ViewColorBy[ViewColorBy["SCHADShiftGroup"] = 4] = "SCHADShiftGroup";
})(ViewColorBy || (exports.ViewColorBy = ViewColorBy = {}));
var ViewGroupBy;
(function (ViewGroupBy) {
    ViewGroupBy[ViewGroupBy["NoGrouping"] = 0] = "NoGrouping";
    ViewGroupBy[ViewGroupBy["Area"] = 1] = "Area";
    ViewGroupBy[ViewGroupBy["Classification"] = 2] = "Classification";
    ViewGroupBy[ViewGroupBy["ShiftTemplate"] = 3] = "ShiftTemplate";
    ViewGroupBy[ViewGroupBy["ServiceType"] = 4] = "ServiceType";
})(ViewGroupBy || (exports.ViewGroupBy = ViewGroupBy = {}));
//# sourceMappingURL=types-roster.js.map